module.exports = __webpack_public_path__ + "static/img/honor2.56064e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/honor2.png
// module id = wZwe
// module chunks = 4